import React from 'react';
import { withTheme, DefaultTheme } from 'styled-components';
import { StyContainer, StyLabelContent } from './styles';
import { Typography } from '../../Typography';

type CircularBarSize = 'x-large' | 'large' | 'medium' | 'small' | 'x-small';
type CircularBarColor = 'neutral' | 'blue' | 'red' | 'orange' | 'green';

interface ICircularBar {
  percentage?: number;
  size?: CircularBarSize;
  color?: CircularBarColor;
  showPercentage?: boolean;
  theme?: DefaultTheme;
}

export const CircularBar: React.FC<ICircularBar> = withTheme(
  ({
    percentage = 0,
    size = 'x-large',
    color = 'green',
    showPercentage = true,
    theme,
  }) => {
    const sizeMap: Record<CircularBarSize, number> = {
      'x-large': 80,
      large: 72,
      medium: 64,
      small: 56,
      'x-small': 48,
    };

    const progressColorMap: Record<CircularBarColor, string> = {
      neutral: theme.neutral[500],
      blue: theme.blue[500],
      red: theme.red[500],
      orange: theme.orange[500],
      green: theme.green[500],
    };

    const progressColor: string = progressColorMap[color];
    const sizeNumber: number = sizeMap[size];
    const radius = sizeNumber / 2 - 5;
    const strokeWidth = 6;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <StyContainer size={sizeNumber}>
        <svg width={sizeNumber} height={sizeNumber}>
          <circle
            cx={sizeNumber / 2}
            cy={sizeNumber / 2}
            r={radius}
            stroke={theme.neutral[700]}
            strokeWidth={strokeWidth}
            fill="none"
          />
        </svg>
        <svg
          width={sizeNumber}
          height={sizeNumber}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            transform: 'rotate(-90deg)',
          }}
        >
          <circle
            cx={sizeNumber / 2}
            cy={sizeNumber / 2}
            r={radius}
            stroke={progressColor}
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            style={{ transition: 'stroke-dashoffset 0.35s ease' }}
          />
        </svg>

        {showPercentage && size !== 'x-small' && (
          <StyLabelContent>
            <Typography.Label size={size !== 'small' ? 'small' : 'x-small'}>
              {percentage}%
            </Typography.Label>
          </StyLabelContent>
        )}
      </StyContainer>
    );
  }
);
